import script from "./SampledCommodityExplainListResult.vue?vue&type=script&setup=true&lang=js"
export * from "./SampledCommodityExplainListResult.vue?vue&type=script&setup=true&lang=js"

import "./SampledCommodityExplainListResult.vue?vue&type=style&index=0&id=73e4e4b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73e4e4b4"]])

export default __exports__